var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.status)?_c('b-row',{staticClass:"loader",attrs:{"align-v":"center"}},[_c('b-col',[_c('b-spinner'),_c('br'),_c('br'),_c('strong',[_vm._v("Loading")])],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }